import * as React from "react";
import { forwardRef } from "react";
const FunnelSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { d: "M14.397 1H1.603a.6.6 0 0 0-.536.318.58.58 0 0 0 .048.62l4.687 6.44.005.007c.17.225.262.496.263.776v5.251a.58.58 0 0 0 .173.416.61.61 0 0 0 .661.126l2.634-.98a.56.56 0 0 0 .392-.549V9.161c0-.28.093-.551.263-.776l.005-.006 4.687-6.442a.58.58 0 0 0 .048-.618.6.6 0 0 0-.536-.319" }));
const ForwardRef = forwardRef(FunnelSVG);
export default ForwardRef;
//# sourceMappingURL=Funnel.js.map